import { cabsLandingerrorMessage } from './cabsLandingErrorMessage';
import { cabsLandingWidgetInfo } from './cabsLandingWidgetInfo';
import {
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS
} from './constants/tripTypes';
import { CityLocation } from './pages/runtime-typechecker';

const SOURCE_INVALID = 'SOURCE_INVALID';
const DESTINATION_INVALID = 'DESTINATION_INVALID';
const AIRPORT_INVALID = 'AIRPORT_INVALID';
const AIRPORT_CITY_INVALID = 'AIRPORT_CITY_INVALID';
const RENTAL_CITY_INVALID = 'RENTAL_CITY_INVALID';
const DEPARURE_DATE_INVALID = 'DEPARURE_DATE_INVALID';
const RETURN_DAT_INVALIDE = 'RETURN_DAT_INVALIDE';
const PICKUP_TIME_INVALID = 'PICKUP_TIME_INVALID';
const DROP_TIME_INVALID = 'DROP_TIME_INVALID';
const SELECTED_PACKAGE_INVALID = 'SELECTED_PACKAGE_INVALID';

const invalidStopOver = (stopOvers: CityLocation[]) => {
  if (!stopOvers || stopOvers.length == 0) return false;

  for (const cityLocation of stopOvers) {
    if (!cityLocation.city || !cityLocation.placeId) return true;
  }
  return false;
};

const duplicateLocations = (cityLocations: CityLocation[]) => {
  if (!cityLocations || cityLocations.length == 0) return false;

  const placeIdSet = new Set<string>();

  for (const cityLocation of cityLocations) {
    if (!cityLocation) continue;

    const { placeId } = cityLocation;

    if (placeIdSet.has(placeId)) {
      return true;
    }
    placeIdSet.add(placeId);
  }
  return false;
};

export const getInvalidWidgetNumber = ({
  travelFor,
  sourceCity,
  destinationCity,
  airport,
  airportCity,
  rentalCity,
  stopOvers
}) => {
  switch (true) {
    case travelFor === OUTSTATION_ONE_WAY:
      return (() => {
        if (sourceCity == null)
          return cabsLandingWidgetInfo.OUTSTATION_PICKUP_LOCATION_WIDGET;
        if (destinationCity == null)
          return cabsLandingWidgetInfo.OUTSTATION_DROP_LOCATION_WIDGET;
      })();
    case travelFor === OUTSTATION_ROUND_TRIP:
      return (() => {
        if (sourceCity == null)
          return cabsLandingWidgetInfo.OUTSTATION_PICKUP_LOCATION_WIDGET;
        if (destinationCity == null)
          return cabsLandingWidgetInfo.OUTSTATION_DROP_LOCATION_WIDGET;
      })();
    case travelFor === CAB_FROM_AIRPORT:
      return (() => {
        if (airport == null)
          return cabsLandingWidgetInfo.FROM_AIRPORT_LOCATION_WIDGET;
        if (airportCity == null)
          return cabsLandingWidgetInfo.FROM_AIRPORT_CITY_LOCATION_WIDGET;
      })();
    case travelFor === CAB_TO_AIRPORT:
      return (() => {
        if (airportCity == null)
          return cabsLandingWidgetInfo.TO_AIRPORT_CITY_LOCATION_WIDGET;
        if (airport == null)
          return cabsLandingWidgetInfo.TO_AIRPORT_LOCATION_WIDGET;
      })();
    case travelFor === RENTALS:
      return (() => {
        if (rentalCity == null)
          return cabsLandingWidgetInfo.RENTAL_PICKUP_LOCATION_WIDGET;
      })();
  }
  return null;
};

export const getInvalidInputMessage = ({
  travelFor,
  sourceCity,
  destinationCity,
  airport,
  airportCity,
  rentalCity,
  stopOvers
}) => {
  switch (true) {
    case travelFor === OUTSTATION_ONE_WAY:
      return (() => {
        if (invalidStopOver(stopOvers))
          return cabsLandingerrorMessage.EMPTY_LOCATION_ERROR_MESSAGE;
        if (duplicateLocations([...stopOvers, sourceCity, destinationCity]))
          return cabsLandingerrorMessage.SAME_LOCATIONS_ERROR_MESSAGE;
      })();
    case travelFor === OUTSTATION_ROUND_TRIP:
      return (() => {
        if (invalidStopOver(stopOvers))
          return cabsLandingerrorMessage.EMPTY_LOCATION_ERROR_MESSAGE;
        if (duplicateLocations([...stopOvers, sourceCity, destinationCity]))
          return cabsLandingerrorMessage.SAME_LOCATIONS_ERROR_MESSAGE;
      })();
    case travelFor === CAB_FROM_AIRPORT:
      return (() => {
        if (airport && airport.cityCode && !airport.cityCode.includes('_AIR'))
          return cabsLandingerrorMessage.PICKUP_ADDRESS_AIRPORT_ERROR_MESSAGE;
        if (duplicateLocations([airport, airportCity]))
          return cabsLandingerrorMessage.SAME_LOCATIONS_ERROR_MESSAGE;
      })();
    case travelFor === CAB_TO_AIRPORT:
      return (() => {
        if (airport && airport.cityCode && !airport.cityCode.includes('_AIR'))
          return cabsLandingerrorMessage.DROP_ADDRESS_AIRPORT_ERROR_MESSAGE;
        if (duplicateLocations([airport, airportCity]))
          return cabsLandingerrorMessage.SAME_LOCATIONS_ERROR_MESSAGE;
      })();
    case travelFor === RENTALS:
      return (() => {
        return null;
      })();
  }
  return null;
};
